// extracted by mini-css-extract-plugin
module.exports = {"formInput":"Form_formInput__456cz","formSubmit":"Form_formSubmit__9PKwC"};